import SpaceOwnership from '../../../../banking/components/account-opening/ownership/SpaceOwnership';

const SpaceOwnershipScreen = () => {
    return <SpaceOwnership />;
};

export default SpaceOwnershipScreen;
